import Vue from 'vue';
import competencies from './lk-competencies';
// import {store} from '../../store';
import leads from './lk-leads';

export default {
    namespaced: true,
    state: {
        linkAuth: '',
        linkLogout: '',
        profile: {},
        isAuth: false,
        staff: [],
        leadsCompleted: [],
        // для мобилки модалки календаря в лидах лк
        modalDatesCalendar: '',
        leadDealNone: false,

        checkedState: [],
    },
    getters: {
        linkAuth(state) {
            return state.linkAuth;
        },
        linkLogout(state) {
            return state.linkLogout;
        },
        profile(state) {
            return state.profile;
        },
        isAuth(state) {
            return state.isAuth;
        },
        isUserAuth (state) {
            return Boolean(state.profile.id);
        },
        staff(state) {
            return state.staff;
        },
        leads(state) {
            return state.leads;
        },
        leadsCompleted(state) {
            return state.leadsCompleted;
        },
        modalDatesCalendar(state) {
            return state.modalDatesCalendar;
        },
        leadDealNone(state) {
            return state.leadDealNone;
        },
        checkedState(state) {
            return state.checkedState;
        },
    },
    mutations: {
        setLinkAuth(state, data) {
            state.linkAuth = data;
        },
        updateRefererLinkAuth(state) {
            state.linkAuth =
                `${state.linkAuth.split('referer=')[0]}referer=${encodeURIComponent(window.location.href)}`;
        },
        setLinkLogout(state, data) {
            state.linkLogout = data;
        },
        updateRefererLinkLogout(state) {
            let link = window.location.href.includes('/lk') ?
                window.location.href.split('/lk')[0] :
                window.location.href;
            state.linkLogout =
                `${state.linkLogout.split('referer=')[0]}referer=${encodeURIComponent(link)}`;
        },
        setModalDatesCalendar(state, data) {
            state.modalDatesCalendar = data;
        },
        setLeadDealNone(state, data) {
            state.leadDealNone = data;
        },
        setProfile(state, data) {
            state.profile = data;
        },
        setNotification(state, data) {
            state.profile.notifications = data;
        },
        setStaff(state, data) {
            state.staff = data;
        },
        setLeads(state, data) {
            state.leads = data;
        },
        setLeadsCompleted(state, data) {
            state.leadsCompleted = data;
        },
        deleteLead(state, index) {
            state.leads.splice(index, 1);
        },
        setItemLeadsTimer(state, data) {
            let item = state.leads.find(el => el.id === data.id);
            item.timer[data.name] = data.value;
        },
        setItemLead(state, data) {
            const index = state.leads.map(el => el.id).indexOf(data.id)
            state.leads[index][data.name] = data.value;
            if (data.name == 'status' && data.value == 2) {
                Vue.set(state.leads[index], 'noConfirm', true)
            }
        },
        logIn(state) {
            state.isAuth = true;
        },
        logOut(state) {
            state.profile = {};
            state.isAuth = false;
        },
        // data - object с полями name и value
        setProfileItem(state, data) {
            state.profile[data.name] = data.value;
        },
        // можно передать id, либо ничего и тогда все отметиться как прочитанное (удалиться из выпадашки)
        deleteProfileNotify(state, id) {
            if (id) {
                // let index = state.profile.notifications.findIndex(item => item.id.toString() === id.toString());
                // state.profile.notifications.splice(index, 1);
                for (let i = 0; i < state.profile.notifications.length; i++) {
                    if (state.profile.notifications[i].id.toString() === id.toString()) {
                        state.profile.notifications.splice(i, 1);
                        break;
                    }
                }
            } else {
                state.profile.notifications = [];
            }
        },
        setCheckedState(state, data) {
            state.checkedState = data.slice();
        },
        deleteCheckedState(state, data) {
            state.checkedState[data.i].splice(data.j, 1);
        },
    },
    actions: {
        // data имеет поле data - отправляемые данные, url - url запроса
        // url: login, registration
        setProfile({ commit }, data) {
            let url = (process.env.NODE_ENV !== 'production') ? 'lk/profile.json' : data.url;
            let method = (process.env.NODE_ENV !== 'production') ? 'get' : 'post';
            return new Promise((resolve, reject) => {
                Vue.http[method](url, data.data)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            commit('setProfile', data.profile);
                            commit('logIn');

                            // store.dispatch('favorite/toggleAllFavorite', 'addFavorite').then();
                            resolve()

                        } else {
                            reject(data);
                        }
                    })
                    .catch((data) => {
                        reject(data);
                    });
            })
        },
        logOut({ commit }) {
            let url = (process.env.NODE_ENV !== 'production') ? 'lk/logout.json' : 'lk/logout';
            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            commit('logOut');

                            // store.dispatch('favorite/clearFavorite').then();
                            resolve();
                        } else {
                            reject(data);
                        }
                    })
                    .catch((data) => {
                        reject(data);
                    });
            })
        },
        // isAuth({commit}) {
        //     let action = process.env.NODE_ENV !== 'production' ? 'lk/isAuth.json' : 'lk/isAuth';
        //
        //     return new Promise((resolve, reject) => {
        //         Vue.http.get(action)
        //             .then(response => response.json())
        //             .then(data => {
        //                 resolve(data);
        //             })
        //             .catch((data) => {
        //                 reject(data);
        //             });
        //     })
        // },
        getNotification({commit}) {
            let action = process.env.NODE_ENV !== 'production' ? 'lk/notifications.json' : 'notifications/new';

                return new Promise((resolve, reject) => {
                    Vue.http.get(action)
                        .then(response => response.json())
                        .then(data => {
                            commit('setNotification', data.items);
                            resolve(data);
                        })
                        .catch((data) => {
                            reject(data);
                        });
                })
        },
    },
    modules: {
        competencies,
        leads
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/lk.js